import React from "react"
import MaterialTable from "material-ui/Table"
import TF from "material-ui/Table/TableFooter"
import TableFooter from "../layout/TableFooter"
import autobind from "class-autobind"
interface IProps<T> {
    height?: string
    fixedHeader?: boolean
    readonly?: boolean
    singleSelectable?: boolean
    allowClickRow?: boolean
    unClickableCols?: number[]
    items: T[]
    selectedItems?: T[]
    uniqueIdentifier?: string
    bodyStyle?: React.CSSProperties
    wrapperStyle?: React.CSSProperties
    handleClickRow?(item: T): void
    handleSelect?(items: T[]): void
    onRowHover?(rowNumber: number): void
    onRowHoverExit?(rowNumber: number): void

    // pagination props
    total?: number
    offset?: number
    limit?: number
    limitOptions?: number[]
    onPageClick?(offset: number): void
    onLimitChange?(limit: number): void

    // select ObjectName. this object should be have "Id"
    // for example, if item is PunchBundle, it should be "Punch"
    selectObjectName?: string
}
interface IState<T> {
    selectedItems: T[]
    showTable: boolean
}

export default class Table<T> extends React.Component<IProps<T>, IState<T>> {
    constructor(props: IProps<T>) {
        super(props)
        this.state = {
            selectedItems: props.selectedItems || [],
            showTable: true,
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps<T>) {
        nextProps.selectedItems &&
            this.state.selectedItems.length !== nextProps.selectedItems.length &&
            this.setState({ selectedItems: nextProps.selectedItems, showTable: false }, () => this.setState({ showTable: true }))
    }

    handelOnCellClick(rowNumber, colId) {
        const uniqueIdentifier = this.props.uniqueIdentifier ? this.props.uniqueIdentifier : "Id"
        const clickedItem = this.props.items[rowNumber]
        if (colId === -1) {
            if (this.props.readonly) return
            let selectedItems = this.state.selectedItems.slice()
            if (this.state.selectedItems.find(item => this.props.selectObjectName ?
                item[this.props.selectObjectName][uniqueIdentifier] === clickedItem[this.props.selectObjectName][uniqueIdentifier] :
                item[uniqueIdentifier] === clickedItem[uniqueIdentifier])
            ) {
                selectedItems = selectedItems.filter(item => this.props.selectObjectName ?
                    item[this.props.selectObjectName][uniqueIdentifier] !== clickedItem[this.props.selectObjectName][uniqueIdentifier] :
                    item[uniqueIdentifier] !== clickedItem[uniqueIdentifier]
                )
            }
            else {
                if (this.props.singleSelectable) {
                    selectedItems = [clickedItem]
                }
                else {
                    selectedItems.push(clickedItem)
                }
            }
            this.setSelectedItems(selectedItems)
        }
        else if (this.props.unClickableCols && this.props.unClickableCols.includes(colId)) return
        else {
            if (this.props.readonly && !this.props.allowClickRow) return
            this.props.handleClickRow &&
                this.props.handleClickRow(clickedItem)
        }
    }

    handleOnRowSelection(result) {
        result === "all" && this.setSelectedItems(this.props.items.slice())
        result === "none" && this.setSelectedItems([])
    }

    setSelectedItems(selectedItems) {
        this.setState({ selectedItems, showTable: false }, () => this.setState({ showTable: true }))
        this.props.handleSelect &&
            this.props.handleSelect(selectedItems)
    }

    render() {
        const children = []
        children[0] = React.cloneElement(this.props.children[0], { key: 0 })
        children[1] = React.cloneElement(this.props.children[1], { key: 1, deselectOnClickaway: false })
        return (
            <MaterialTable
                height={this.props.height}
                fixedHeader={this.props.fixedHeader}
                allRowsSelected={this.props.items.length === this.state.selectedItems.length && this.state.selectedItems.length > 0}
                multiSelectable={!this.props.readonly && !this.props.singleSelectable}
                selectable={!this.props.readonly}
                bodyStyle={this.props.bodyStyle ? this.props.bodyStyle : null}
                wrapperStyle={this.props.wrapperStyle ? this.props.wrapperStyle : null}
                onCellClick={this.handelOnCellClick}
                onRowSelection={this.handleOnRowSelection}
                onRowHover={this.props.onRowHover}
                onRowHoverExit={this.props.onRowHoverExit}
            >
                {children}
                {this.props.limit &&
                    <TF>
                        <TableFooter
                            total={this.props.total}
                            offset={this.props.offset}
                            limit={this.props.limit}
                            limitOptions={this.props.limitOptions}
                            onPageClick={this.props.onPageClick}
                            onLimitChange={this.props.onLimitChange}
                        />
                    </TF>
                }
            </MaterialTable>
        )
    }
}

